import React from "react";
import "../RightSection/RightSection.css";
import Button from "../Button/Button";

export default function LeftImage({
  Subtitle,
  Paragraph,
  btnLink,
  btnText,
  SideImage,
}) {

  return (
    <div className="row section_align_items">
      <div className="section_image layout-col-lg-6 layout-col-sm-12 one">
        <img src={SideImage} alt="about section" />
      </div>
      <div className="layout-col-lg-6 layout-col-sm-12 two text">
        <h1>{Subtitle}</h1>
        <p>{Paragraph}</p>
        {btnLink === "" && btnText === "" ? "" : <Button btnLink={btnLink} btnText={btnText} />}
      </div>
    </div>
  );
}
